import { type RouteObject } from 'react-router'

import { REQUEST_CHARTS_URL, TRIAL } from 'features/trial/paths'
import { lazyComponent } from 'routes/lazy-route'

export const trialRoutes: RouteObject[] = [
  {
    path: TRIAL,
    lazy: lazyComponent(
      () => import('features/trial/Container'),
      'TrialContainer',
    ),
    children: [
      {
        path: REQUEST_CHARTS_URL,
        lazy: lazyComponent(
          () => import('features/trial/components/RequestDashboardForm'),
          'RequestDashboardForm',
        ),
      },
    ],
  },
]
